import React from 'react'
import { ToggleButton } from '@material-ui/lab'
import { useSegmentedToggleButtonStyles } from 'lib/segmented-button-styles'
import { SegmentedToggleButtonContent } from './segmented-toggle-button-content'

export function SegmentedToggleButton({
  children,
  groupValue,
  value,
  showCheck = true,
  className,
  ...props
}) {
  const classes = useSegmentedToggleButtonStyles()
  const isSelected = groupValue === value

  return (
    <ToggleButton
      value={value}
      className={[classes.root, className].filter(Boolean).join(' ')}
      {...props}
    >
      <SegmentedToggleButtonContent
        isSelected={isSelected}
        showCheck={showCheck}
      >
        {children}
      </SegmentedToggleButtonContent>
    </ToggleButton>
  )
}

export { SegmentedToggleButton as default }
